
import React from 'react'
import { RouteModal } from 'components/RouteModal'
import styled from 'styled-components'
import { getModalPath } from 'utils/getModalPath'
import { useLocation, useNavigate } from 'react-router-dom'
import { Wrapper } from 'containers/OrderTypeModal'
import { OptionCard } from 'components/OptionCard'
import { faBuilding, faUser, IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { T } from '@nv/react-commons/src/Components'

const StyledModal = styled(RouteModal)`
  .ant-modal-content {
    border-radius: 10px;
    > div {
      background-color: unset;
    }
  }

  .ant-modal-title {
    border-radius: 10px;
  }
`

function RecipientTypeModal() {
    const location = useLocation()
    const navigate = useNavigate()

    const navigateTo = (recipientType: string) => {
        const path = `${location.pathname
            .split('/')
            .slice(0, -1)
            .join('/')}/select-order-type-${recipientType}`
        navigate(-1)
        setTimeout(() => navigate(path), 0)
    }

    const createRecipientCard = (type: 'b2b' | 'b2c', icon: IconDefinition, label: string, description: string) => (
        <Wrapper isLink onLinkClick={() => navigateTo(type)}>
            <OptionCard icon={icon} label={label} description={description} />
        </Wrapper>
    )

    return (
        <StyledModal path={getModalPath(location, 'select-recipient-type')} title={<T id='choose_recipient_type' />}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {createRecipientCard('b2c', faUser, 'business_to_customer', 'business_to_customer_description')}
                {createRecipientCard('b2b', faBuilding, 'business_to_business', 'business_to_business_description')}
            </div>
        </StyledModal>
    )
}

export default RecipientTypeModal